<div id="unitViewDesktop" *ngIf="model">
  <h3>Unidad</h3>
  <div class="photoAndData">
    <div class="data">
      <div class="wrapperG3">
        <div class="controlWrapper">
          <label>Tipo de unidad</label>
          <span class="value">{{ getModel(model.modelType) }}</span>
        </div>
        <div class="controlWrapper">
          <label>Condición</label>
          <span class="value">{{ getClassification(model.classification) }}</span>
        </div>
        <div class="controlWrapper">
          <label>Año</label>
          <span class="value">{{ model.year }}</span>
        </div>
      </div>
      <div class="wrapperG2">
        <div class="controlWrapper">
          <label>Modelo</label>
          <span class="value">{{ getModelNameWithCode(model) }}</span>
        </div>
        <div class="wrapperG4Custom">
          <div class="controlWrapper">
            <label>Precio</label>
            <span class="value">{{ model.price | currency : '' : '' }}</span>
          </div>
          <div class="controlWrapper">
            <label>Mon. fact.</label>
            <span class="value">{{ model.currency }}</span>
          </div>
          <div class="controlWrapper">
            <label>Cant.</label>
            <span class="value">{{ quantiyForm }}</span>
          </div>
          <div class="controlWrapper">
            <label>Total venta</label>
            <span class="value">{{ model.price * quantiyForm | currency }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- Imagen -->
    <div class="photo">
      @if(subBrandImg() !== "") {
      <picture>
        <img
          src="{{ subBrandImg() }}"
          width="218"
          height="132"
          alt="Subrand model image"
          decoding="async"
          loading="lazy"
        />
      </picture>
      } @else {
      <div class="noImage">
        <span>Sin imagen</span>
      </div>
      }
    </div>
  </div>
</div>
